<template>
  <div class="logs">
    <Nav/>


    <div class="top" v-if="detail">
      <div class="item">
        <span class="t1">订单编号：</span>
        <span class="t2">{{ sn }}</span>
      </div>
      <div class="item">
        <span class="t1">运单号：</span>
        <span class="t2">{{ detail.express_content.express_sn }}</span>
      </div>
      <div class="item">
        <span class="t1">承运公司：</span>
        <span class="t2">{{ detail.express_content.express_company }}</span>
      </div>
      <!-- <div class="item">
        <span class="t1">官方电话：</span>
        <span class="t2 on">95546</span>
      </div> -->
    </div>
    <Logs :logs="detail.logs"/>
  </div>
</template>

<style lang="less" scoped>
.logs {
  .top {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    padding: 30px 24px;
    .item {
      font-size: 24px;
      margin: 12px 0;
      .t1 {
        color: #666;
      }
      .t2 {
        font-size: #333;
        margin-left: 10px;
      }
      .on {
        color: #e42129;
      }
    }
  }
}
</style>

<script>
import Logs from "../../component/Logistics";
export default {
  components: {
    Logs
  },
  data(){
    return{
      detail:null,
      sn:null
    }
  },
  created() {
    let { id,sn } = this.$route.query;
    this.sn = sn
    this.$http({
      url: "orderDeatil",
      data: {
        id
      }
    }).then(res => {
      console.log(res)
      let { express_content } = res
      let logs = express_content.Traces.reverse();
      logs.forEach(item => (item.AcceptTime = item.AcceptTime.split(/\s+/)));

      this.detail = {express_content,logs}
      console.log(this.detail)
    });
  }
};
</script>
